"use client";

import { useCallback } from "react";

import { useParams, usePathname } from "next/navigation";

import { buildLocalizedHref, normalizeLocale, splitLocaleFromPathname } from "../lib/routeUtils";

export default function useLocalizedHref() {
  const params = useParams();
  const pathname = usePathname();
  const { locale: pathLocale } = splitLocaleFromPathname(pathname || "");
  const paramLocale = typeof params?.locale === "string" ? params.locale : null;
  const locale = normalizeLocale(paramLocale || pathLocale);

  const buildHref = useCallback((path, searchParams) => buildLocalizedHref(locale, path, searchParams), [locale]);

  return { locale, buildHref };
}
